﻿import '@styles/app.css'
import { initSite } from '@layout/site'
import { mount } from '@shared'
import { ContactUpdation } from '@features/Services/ContactUpdation'

initSite()
mount('react-root', <ContactUpdation />)
